import { Alert } from "@jugl-web/ui-components";
import React, { useMemo } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { useTranslations } from "@jugl-web/utils";
import alertAnimation from "./assets/alert-animation.json";

export const ManageContactAlert: React.FC<{
  isOpen: boolean;
  type: "block" | "unblock";
  phoneNumber: string;
  onConfirm: () => void;
  onRequestClose: () => void;
}> = ({ isOpen, type, phoneNumber, onConfirm, onRequestClose }) => {
  const { t } = useTranslations();

  const { title, content, buttonText } = useMemo(() => {
    if (type === "block") {
      return {
        title: t({
          id: "client-support-page.block-user",
          defaultMessage: "Block User",
        }),
        content: t(
          {
            id: "client-support-page.block-user-confirmation",
            defaultMessage:
              "You are sure you want to block user {phoneNumber}? User will no longer be able to contact Support Chat using this Phone Number",
          },
          {
            phoneNumber: (
              <span className="font-medium, text-primary-800">
                {phoneNumber}
              </span>
            ),
          }
        ),
        buttonText: t({
          id: "client-support-page.block",
          defaultMessage: "Block",
        }),
      };
    }

    return {
      title: t({
        id: "client-support-page.unblock-user",
        defaultMessage: "Unblock User",
      }),
      content: t(
        {
          id: "client-support-page.unblock-user-confirmation",
          defaultMessage:
            "You are sure you want to unblock user {phoneNumber}? User will be able to contact Support Chat using this Phone Number",
        },
        {
          phoneNumber: (
            <span className="font-medium, text-primary-800">{phoneNumber}</span>
          ),
        }
      ),
      buttonText: t({
        id: "client-support-page.unblock",
        defaultMessage: "Unblock",
      }),
    };
  }, [type, phoneNumber, t]);

  return (
    <Alert
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      img={
        <Lottie
          options={{ animationData: alertAnimation }}
          width={70}
          height={70}
        />
      }
      title={title}
      content={content}
      buttons={[
        {
          text: t({
            id: "common.cancel",
            defaultMessage: "Cancel",
          }),
          role: "close",
        },
        {
          text: buttonText,
          onClick: onConfirm,
          color: type === "block" ? "tertiary" : "primary",
        },
      ]}
    />
  );
};
